<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.25 15.0002L5.495 8.20399C5.27875 6.25899 7.28125 4.83024 9.05 5.66899L23.98 12.7415C25.8863 13.644 25.8863 16.3565 23.98 17.259L9.05 24.3327C7.28125 25.1702 5.27875 23.7427 5.495 21.7977L6.25 15.0002ZM6.25 15.0002H15"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
